{
  "version": 1,
  "source": "punks.art/api/traits",
  "traitIdMax": 110,
  "traits": {
    "0": {
      "name": "Male 1",
      "category": "Type"
    },
    "1": {
      "name": "Male 2",
      "category": "Type"
    },
    "2": {
      "name": "Male 3",
      "category": "Type"
    },
    "3": {
      "name": "Male 4",
      "category": "Type"
    },
    "4": {
      "name": "Female 1",
      "category": "Type"
    },
    "5": {
      "name": "Female 2",
      "category": "Type"
    },
    "6": {
      "name": "Female 3",
      "category": "Type"
    },
    "7": {
      "name": "Female 4",
      "category": "Type"
    },
    "8": {
      "name": "Zombie Male",
      "category": "Type"
    },
    "9": {
      "name": "Ape Male",
      "category": "Type"
    },
    "10": {
      "name": "Alien Male",
      "category": "Type"
    },
    "11": {
      "name": "Rosy Cheeks",
      "category": "Skin Markings"
    },
    "12": {
      "name": "Luxurious Beard",
      "category": "Facial Hair"
    },
    "13": {
      "name": "Clown Hair Green",
      "category": "Hairstyle"
    },
    "14": {
      "name": "Mohawk Dark",
      "category": "Hairstyle"
    },
    "15": {
      "name": "Cowboy Hat",
      "category": "Headwear"
    },
    "16": {
      "name": "Mustache",
      "category": "Facial Hair"
    },
    "17": {
      "name": "Clown Nose",
      "category": "Nose"
    },
    "18": {
      "name": "Cigarette",
      "category": "Mouth Accessories"
    },
    "19": {
      "name": "Nerd Glasses",
      "category": "Eyewear"
    },
    "20": {
      "name": "Regular Shades",
      "category": "Eyewear"
    },
    "21": {
      "name": "Knitted Cap",
      "category": "Headwear"
    },
    "22": {
      "name": "Shadow Beard",
      "category": "Facial Hair"
    },
    "23": {
      "name": "Frown",
      "category": "Mouth"
    },
    "24": {
      "name": "Cap Forward",
      "category": "Headwear"
    },
    "25": {
      "name": "Goat",
      "category": "Facial Hair"
    },
    "26": {
      "name": "Mole",
      "category": "Skin Markings"
    },
    "27": {
      "name": "Purple Hair",
      "category": "Hairstyle"
    },
    "28": {
      "name": "Small Shades",
      "category": "Eyewear"
    },
    "29": {
      "name": "Shaved Head",
      "category": "Hairstyle"
    },
    "30": {
      "name": "Classic Shades",
      "category": "Eyewear"
    },
    "31": {
      "name": "Vape",
      "category": "Mouth Accessories"
    },
    "32": {
      "name": "Silver Chain",
      "category": "Neck"
    },
    "33": {
      "name": "Smile",
      "category": "Mouth"
    },
    "34": {
      "name": "Big Shades",
      "category": "Eyewear"
    },
    "35": {
      "name": "Mohawk Thin",
      "category": "Hairstyle"
    },
    "36": {
      "name": "Beanie",
      "category": "Headwear"
    },
    "37": {
      "name": "Cap",
      "category": "Headwear"
    },
    "38": {
      "name": "Clown Eyes Green",
      "category": "Eye Makeup"
    },
    "39": {
      "name": "Normal Beard Black",
      "category": "Facial Hair"
    },
    "40": {
      "name": "Medical Mask",
      "category": "Mouth Accessories"
    },
    "41": {
      "name": "Normal Beard",
      "category": "Facial Hair"
    },
    "42": {
      "name": "VR",
      "category": "Eyewear"
    },
    "43": {
      "name": "Eye Patch",
      "category": "Eyewear"
    },
    "44": {
      "name": "Wild Hair",
      "category": "Hairstyle"
    },
    "45": {
      "name": "Top Hat",
      "category": "Headwear"
    },
    "46": {
      "name": "Bandana",
      "category": "Headwear"
    },
    "47": {
      "name": "Handlebars",
      "category": "Facial Hair"
    },
    "48": {
      "name": "Frumpy Hair",
      "category": "Hairstyle"
    },
    "49": {
      "name": "Crazy Hair",
      "category": "Hairstyle"
    },
    "50": {
      "name": "Police Cap",
      "category": "Headwear"
    },
    "51": {
      "name": "Buck Teeth",
      "category": "Mouth"
    },
    "52": {
      "name": "Do-rag",
      "category": "Headwear"
    },
    "53": {
      "name": "Front Beard",
      "category": "Facial Hair"
    },
    "54": {
      "name": "Spots",
      "category": "Skin Markings"
    },
    "55": {
      "name": "Big Beard",
      "category": "Facial Hair"
    },
    "56": {
      "name": "Vampire Hair",
      "category": "Hairstyle"
    },
    "57": {
      "name": "Peak Spike",
      "category": "Hairstyle"
    },
    "58": {
      "name": "Chinstrap",
      "category": "Facial Hair"
    },
    "59": {
      "name": "Fedora",
      "category": "Headwear"
    },
    "60": {
      "name": "Earring",
      "category": "Ear"
    },
    "61": {
      "name": "Horned Rim Glasses",
      "category": "Eyewear"
    },
    "62": {
      "name": "Headband",
      "category": "Headwear"
    },
    "63": {
      "name": "Pipe",
      "category": "Mouth Accessories"
    },
    "64": {
      "name": "Messy Hair",
      "category": "Hairstyle"
    },
    "65": {
      "name": "Front Beard Dark",
      "category": "Facial Hair"
    },
    "66": {
      "name": "Hoodie",
      "category": "Headwear"
    },
    "67": {
      "name": "Gold Chain",
      "category": "Neck"
    },
    "68": {
      "name": "Muttonchops",
      "category": "Facial Hair"
    },
    "69": {
      "name": "Stringy Hair",
      "category": "Hairstyle"
    },
    "70": {
      "name": "Eye Mask",
      "category": "Eyewear"
    },
    "71": {
      "name": "3D Glasses",
      "category": "Eyewear"
    },
    "72": {
      "name": "Clown Eyes Blue",
      "category": "Eye Makeup"
    },
    "73": {
      "name": "Mohawk",
      "category": "Hairstyle"
    },
    "74": {
      "name": "Pilot Helmet",
      "category": "Headwear"
    },
    "75": {
      "name": "Tassle Hat",
      "category": "Headwear"
    },
    "76": {
      "name": "Hot Lipstick",
      "category": "Lip Makeup"
    },
    "77": {
      "name": "Blue Eye Shadow",
      "category": "Eye Makeup"
    },
    "78": {
      "name": "Straight Hair Dark",
      "category": "Hairstyle"
    },
    "79": {
      "name": "Choker",
      "category": "Neck"
    },
    "80": {
      "name": "Crazy Hair",
      "category": "Hairstyle"
    },
    "81": {
      "name": "Regular Shades",
      "category": "Eyewear"
    },
    "82": {
      "name": "Wild Blonde",
      "category": "Hairstyle"
    },
    "83": {
      "name": "3D Glasses",
      "category": "Eyewear"
    },
    "84": {
      "name": "Mole",
      "category": "Skin Markings"
    },
    "85": {
      "name": "Wild White Hair",
      "category": "Hairstyle"
    },
    "86": {
      "name": "Spots",
      "category": "Skin Markings"
    },
    "87": {
      "name": "Frumpy Hair",
      "category": "Hairstyle"
    },
    "88": {
      "name": "Nerd Glasses",
      "category": "Eyewear"
    },
    "89": {
      "name": "Tiara",
      "category": "Headwear"
    },
    "90": {
      "name": "Orange Side",
      "category": "Hairstyle"
    },
    "91": {
      "name": "Red Mohawk",
      "category": "Hairstyle"
    },
    "92": {
      "name": "Messy Hair",
      "category": "Hairstyle"
    },
    "93": {
      "name": "Clown Eyes Blue",
      "category": "Eye Makeup"
    },
    "94": {
      "name": "Pipe",
      "category": "Mouth Accessories"
    },
    "95": {
      "name": "Wild Hair",
      "category": "Hairstyle"
    },
    "96": {
      "name": "Purple Eye Shadow",
      "category": "Eye Makeup"
    },
    "97": {
      "name": "Stringy Hair",
      "category": "Hairstyle"
    },
    "98": {
      "name": "Dark Hair",
      "category": "Hairstyle"
    },
    "99": {
      "name": "Eye Patch",
      "category": "Eyewear"
    },
    "100": {
      "name": "Blonde Short",
      "category": "Hairstyle"
    },
    "101": {
      "name": "Classic Shades",
      "category": "Eyewear"
    },
    "102": {
      "name": "Eye Mask",
      "category": "Eyewear"
    },
    "103": {
      "name": "Clown Hair Green",
      "category": "Hairstyle"
    },
    "104": {
      "name": "Cap",
      "category": "Headwear"
    },
    "105": {
      "name": "Medical Mask",
      "category": "Mouth Accessories"
    },
    "106": {
      "name": "Bandana",
      "category": "Headwear"
    },
    "107": {
      "name": "Purple Lipstick",
      "category": "Lip Makeup"
    },
    "108": {
      "name": "Clown Nose",
      "category": "Nose"
    },
    "109": {
      "name": "Headband",
      "category": "Headwear"
    },
    "110": {
      "name": "Pigtails",
      "category": "Hairstyle"
    },
    "111": {
      "name": "Straight Hair Blonde",
      "category": "Hairstyle"
    },
    "112": {
      "name": "Knitted Cap",
      "category": "Headwear"
    },
    "113": {
      "name": "Clown Eyes Green",
      "category": "Eye Makeup"
    },
    "114": {
      "name": "Cigarette",
      "category": "Mouth Accessories"
    },
    "115": {
      "name": "Welding Goggles",
      "category": "Headwear"
    },
    "116": {
      "name": "Mohawk Thin",
      "category": "Hairstyle"
    },
    "117": {
      "name": "Gold Chain",
      "category": "Neck"
    },
    "118": {
      "name": "VR",
      "category": "Eyewear"
    },
    "119": {
      "name": "Vape",
      "category": "Mouth Accessories"
    },
    "120": {
      "name": "Pink With Hat",
      "category": "Hairstyle"
    },
    "121": {
      "name": "Blonde Bob",
      "category": "Hairstyle"
    },
    "122": {
      "name": "Mohawk",
      "category": "Hairstyle"
    },
    "123": {
      "name": "Big Shades",
      "category": "Eyewear"
    },
    "124": {
      "name": "Earring",
      "category": "Ear"
    },
    "125": {
      "name": "Green Eye Shadow",
      "category": "Eye Makeup"
    },
    "126": {
      "name": "Straight Hair",
      "category": "Hairstyle"
    },
    "127": {
      "name": "Rosy Cheeks",
      "category": "Skin Markings"
    },
    "128": {
      "name": "Half Shaved",
      "category": "Hairstyle"
    },
    "129": {
      "name": "Mohawk Dark",
      "category": "Hairstyle"
    },
    "130": {
      "name": "Black Lipstick",
      "category": "Lip Makeup"
    },
    "131": {
      "name": "Horned Rim Glasses",
      "category": "Eyewear"
    },
    "132": {
      "name": "Silver Chain",
      "category": "Neck"
    }
  }
}